module.exports = __webpack_public_path__ + "img/logo1.32b26d1c.png";